import { useNavigate } from "react-router";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { Faq, filterAndSort, setFaqOrderValue } from "../../faq/faqSlice";
import { useState, useEffect } from "react";
import { useAuth } from "react-oidc-context";

export const VendorListTools = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const faqstate = useAppSelector(state => state.faqstate);
  const auth = useAuth();

  const [faqs, setFaqs] = useState([] as Faq[])

  useEffect( () => {
    setFaqs(filterAndSort(faqstate.faqs,'vendors'));
  }, [faqstate.faqs])
  
  const handleAdd = async () => {
    // need to pass the order value to the add/edit
    dispatch(setFaqOrderValue(faqs.length));

    setTimeout(() => {
      // cant think of a way to ensure that the state has changed before calling the navigate
      // hence this hack
      navigate(`/vendorfaq-add`);
    }, 1000)

  }
 

  return (
      <div className="padded-spread-container lr-padded-container">
      { auth.isAuthenticated && (
        <button
          type='button'
          className='btn'
          style={{marginLeft: '0.5rem'}}
          onClick={() => handleAdd()}
        >
          Add
        </button>
      )}

        <div className="default-container" style={{display: 'none'}}>
          {faqs.length === 0 ? 'No FAQs to display...' : faqs.length > 1 ? faqs.length + ' FAQs found' : '1 FAQ found'}
        </div>
        <div className="default-container"></div>
        <div className="default-container">
        {/* probably nothing */}

        </div>
      </div>

  );
}